import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative inline-flex" }
const _hoisted_2 = {
  key: 0,
  class: "absolute -right-2 -top-1 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-foreground px-1 text-[10px] leading-none text-background"
}

import { computed } from 'vue';

import useContext from '@/composables/useContext';
import useGiftCard from '@/composables/useGiftCard';
import FavoriteButton from '@/components/FavoriteButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FavoritesHeaderLink',
  setup(__props) {

const { channel } = useContext();
const { activeGiftCard } = useGiftCard();

const favoritesPageUrl = computed(() => channel.value?.giftcardFavoritesPageUrl || '');
const amountOfFavorites = computed(() => activeGiftCard.value?.favoriteProductIds?.length || 0);
const hasFavorites = computed(() => amountOfFavorites.value > 0);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (favoritesPageUrl.value)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: favoritesPageUrl.value,
        class: "inline-flex items-center text-foreground transition-colors hover:opacity-70",
        "aria-label": "Favorites"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _createVNode(FavoriteButton, {
              "is-favorite": hasFavorites.value,
              size: "sm",
              class: "pointer-events-none"
            }, null, 8, ["is-favorite"]),
            (hasFavorites.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(amountOfFavorites.value), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}
}

})